/**
 * Vérifie que la chaîne passée correspond à la structure d'un JWT
 * (trois parties séparées par des points, composées de caractères alphanumériques, '-' et '_').
 */
export function isValidJWT(token) {
  if (!token || typeof token !== 'string') return false;
  const jwtPattern = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/;
  return jwtPattern.test(token);
}

/**
 * Récupère le token depuis le localStorage, le vérifie et le nettoie s’il n’est pas conforme.
 * Retourne le token s’il est valide, sinon null.
 */
export function validateAndCleanXsrfToken() {
  const token = localStorage.getItem('xsrfToken');

  if (token) {
    if (!isValidJWT(token)) {
      localStorage.removeItem('xsrfToken');
      return null;
    }
  }
  return token;
}
